window.rotated = false;
window.autoRotatePopIn = () => {
  // if (window.innerWidth < window.innerHeight) {
  if (window.rotated) {
    $('.zoom-fullscreen-container').removeClass('rotate');
  } else {
    var $containers = $('.zoom-fullscreen-container:visible');
    if ($containers.length) {
      $containers.each(function () {
        if (!$(this).hasClass('rotate')) {
          $(this).addClass('rotate');
        }
      });
    }
  }

  window.rotated = !window.rotated;
}

// window.addEventListener("resize", () => {
//   autoRotatePopIn();
// });

window.createFullscreenContainer = () => {
  const newDiv = document.createElement("div");
  newDiv.id = 'zoom-fullscreen-main';
  newDiv.innerHTML = `
  <div class="zoom-fullscreen-mask">
    <div class="zoom-fullscreen-wrapper" style="cursor: zoom-out" onclick="$('#zoom-fullscreen-main').fadeToggle('fast', 'linear');">
      <div class="zoom-fullscreen-container">
        <img id="zoom-fullscreen-img" class="box-shadow-hard" src="" alt="" />
        <div class="close"><i class="fa-solid fa-times"></i></div>
        <div class="alt"><span>Text alternatif</span></div>
      </div>
    </div>
    <div class="zoom-fullscreen-options">
      <button onclick="window.autoRotatePopIn()" class="btn btn-dark btn-lg">
        <i class="fa-solid fa-camera-rotate"></i>
      </button>
    </div>
  </div>`;
  const currentDiv = document.getElementById('body');
  document.body.insertBefore(newDiv, currentDiv);
}

window.fullscreenImgSrc = (img) => {
  if (!img.src) {
    return false;
  }
  $('#zoom-fullscreen-img').attr('src', img.src);
  var alt = img.alt ? img.alt : '';
  $('#zoom-fullscreen-img').attr('alt', alt);
  if (alt) {
    $('#zoom-fullscreen-main .alt > span').show().html(alt);
  } else {
    $('#zoom-fullscreen-main .alt > span').hide();
  }
};

window.activateFullscreenImgs = () => {
  $('img.zoom-fullscreen-click').each(function () {
    if (!$(this).hasClass('zoom-fullscreen-rendered')
      && !$(this).siblings().first().hasClass('zoom-icon')) {

      if ($(this).parent().css('position') != 'relative') {
        $(this).parent().addClass('position-relative');
      }
    }

    $(this).on('click', () => {
      if (!$('#zoom-fullscreen-main').length || $('#zoom-fullscreen-main').is(':hidden')) {
        fullscreenImgSrc(this);
        $('#zoom-fullscreen-main').fadeToggle('fast', 'linear');
      }
    })
      .addClass('zoom-fullscreen-rendered');
  });
}

createFullscreenContainer();